window.$ = jQuery;
import gsap from "gsap";

const dropdowns = (function () {
  var mouseEntered = false;
  var bigDropdownOpen = false;

  $(".nav-header .menu-item > a").not(".sub-menu a").on("click", function(e) {
    e.preventDefault();
    if ($(this).parent().find(".sub-menu").length && $(this).parent().hasClass("active")) {
      window.location.href = $(this).attr("href");
    } else if (!$(this).parent().find(".sub-menu").length) {
      window.location.href = $(this).attr("href");
    } else {
      return false;
    }
  });

  $(".nav-header .menu-item.menu-item-has-children a").on("mouseenter focus", function (e) {
    var $submenu = $(this).parent().find(".sub-menu");
    var $dropdownWrap = $(".dropdowns");
    var $that = $(this);
    if ($dropdownWrap.is(":visible")) {
      hideDropdown();
    }
    if (!$submenu.is(":visible")) {
      gsap.fromTo(
        $submenu,
        { 
          opacity: 0, 
          display: "none",
          y: -10
        },
        {
          opacity: 1,
          display: "block",
          duration: 0.25,
          y: 0,
          ease: "power2.out",
          callback: function () {
            window.setTimeout(function() {
              $that.parent().addClass("active");
            }, 100);
            bindHideTinyDropdown($that.parent());
          }
        }
      );
    }
  });

  function bindHideTinyDropdown($this) {

    var theclasses = $this.attr("class");
    theclasses = theclasses.split(" ");
    theclasses = theclasses.join(".");
    theclasses = "." + theclasses;

    $("body *").on("mouseenter.tinynav focus.tinynav", function (e) {
      if (
        $(e.target).parents(theclasses).length == 0 &&
        $(e.target).is($this) == false
      ) {
            hideTinyDropdown($this);
      }
    });
  }

  function hideTinyDropdown($this) {
    var $submenu = $this.find(".sub-menu");
    $("body *").off("mouseenter.tinynav focus.tinynav");
    if ($submenu.is(":visible")) {
      gsap.fromTo(
        $submenu,
        { opacity: 1, display: "block" },
        {
          opacity: 0,
          display: "none",
          duration: 0.25,
          ease: "power2.out",
          callback: function () {
            window.setTimeout(function() {
              $this.removeClass("active");
            }, 100);
          }
        }
      );
    }
  };


  $(".nav-header .menu-item:not(.menu-item-has-children) a").on("mouseover focus", function (e) {
    var title = $(this).text();
    var $dropdownWrap = $(".dropdowns");
    var $dropdown = $(".dropdown[data-dropdown='" + title + "']");

    if (mouseEntered) {
      if (mouseEntered.text() == title) {
        return;
      }
    }

    mouseEntered = $(this);

    $(this).parent().addClass("active");

    if (!$dropdown.length) {
      hideDropdown();
    } else if ($dropdown.length && bigDropdownOpen) {
      gotoDropdown($dropdown);
    } else {
      bigDropdownOpen = true;
      gsap.fromTo(
        $dropdownWrap,
        { opacity: 0, display: "none" },
        { opacity: 1, display: "block", duration: 0.25, ease: "power2.out" }
      );
      gotoDropdown($dropdown);
      bindHideDropdown();
    }
  });

  function bindHideDropdown() {
    $("body *").on("mouseenter.nav", function (e) {
      if (
        $(e.target).parents(".dropdowns").length == 0 &&
        $(e.target).parents(".nav-header").length == 0
      ) {
        if (
          !$(e.target).hasClass("dropdowns") &&
          !$(e.target).hasClass("nav-header")
        ) {
          hideDropdown();
        }
      }
    });
  }

  function gotoDropdown($dropdown) {
    var tl = gsap.timeline();
    var $currentDropdown = $(".dropdown:visible");
      if ($currentDropdown.length) {
        tl.fromTo(
          $currentDropdown,
          { opacity: 1, y: 0 },
          {
            opacity: 0,
            y: -50,
            display: "none",
            duration: 0.25,
            ease: "power2.out",
          }
        );
      }
      tl.fromTo(
        $dropdown,
        { opacity: 0, y: -50 },
        {
          opacity: 1,
          y: 0,
          duration: 0.25,
          display: "flex",
          ease: "power2.out",
          callback: function () {
              //on next tab key down press, focus on the first link in the dropdown
              $("body").on("keydown", function(e) {
                  if(e.keyCode === 9) {
                      e.preventDefault();
                      $dropdown.find("a").first().focus();
                      $("body").off("keydown");
                  }
              });
              $dropdown.find("a").last().on("focus", function() {
                  $("body").on("keydown", function(e) {
                      if(e.keyCode === 9) {
                          e.preventDefault();
                          var dropdownName =  $dropdown.attr("data-dropdown");
                          var nextMenuItem = $(".nav-header .menu-item a:contains('" + dropdownName + "')").parent().next().find("a");
                          if(nextMenuItem.length) {
                              nextMenuItem.focus();
                          } else {
                              hideDropdown();
                              $(".gtranslate_wrapper select").focus();
                          }
                          $("body").off("keydown");
                      }
                  });
              });
          }
        }
      );
  }

  function hideDropdown() {
    console.log("hideDropdown");
    $("body *").off("mouseenter.nav");
    var $dropdownWrap = $(".dropdowns");
    var $dropdown = $(".dropdown");
    $(".nav-header .menu-item").removeClass("active");
    gsap.fromTo(
      $dropdownWrap,
      { opacity: 1 },
      { opacity: 0, display: "none", duration: 0.25, ease: "power2.out" }
    );
    gsap.fromTo(
      $dropdown,
      { opacity: 1, },
      {
        opacity: 0,
        display: "none",
        duration: 0.25,
        ease: "power2.out",
        callback: function () {
          bigDropdownOpen = false;
        },
      }
    );
    mouseEntered = false;
  }
})();

export default dropdowns;
